import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { validLangs } from '@/mocks/languages';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLang = lang && validLangs.includes(lang) ? lang : 'en';

  return (
    <footer className="mt-16 bg-secondary-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-table-line text-lg"></i>
            </span>
            <span className="font-heading font-semibold text-foreground-950">AllChinaBuy Spreadsheet</span>
          </div>
          <p className="text-sm text-foreground-700 leading-relaxed">
            {t('common.footer.disclaimer')}
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground-950 mb-3">
            <Link to={`/${currentLang}`} className="text-foreground-950 hover:text-primary-600 transition-colors">
              {t('common.nav.categories')}
            </Link>
          </h4>
          <div className="flex flex-col gap-2">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
              {t('common.footer.safety')}
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
              {t('common.footer.privacy')}
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
              {t('common.footer.terms')}
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
              {t('common.footer.about')}
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-foreground-950 mb-3">
            {t('home.cta.title')}
          </h4>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors"
          >
            {t('home.cta.button')}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} AllChinaBuy Spreadsheet. {t('common.footer.copyright')}
          </p>
          <p className="text-xs text-foreground-600">
            {t('common.footer.disclaimerTitle')}
          </p>
        </div>
      </div>
    </footer>
  );
}